import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook, FiUsers, FiTrendingUp, FiArrowRight } = FiIcons;

const HomePage = () => {
  const features = [
    {
      icon: FiBook,
      title: 'Interaktive Geschichten',
      description: 'Erstellen Sie fesselnde entscheidungsbasierte Geschichten mit integrierten Quizzen und verzweigten Pfaden.'
    },
    {
      icon: FiUsers,
      title: 'Schülerengagement',
      description: 'Schüler navigieren anonym durch Geschichten und treffen Entscheidungen, die ihre Reise beeinflussen.'
    },
    {
      icon: FiTrendingUp,
      title: 'Visueller Editor',
      description: 'Intuitiver Drag-and-Drop-Flow-Editor zur einfachen Gestaltung komplexer Geschichtsstrukturen.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <motion.section
        className="text-white py-20"
        style={{ backgroundColor: '#2b6777' }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            className="text-5xl md:text-6xl font-bold mb-6 font-rubik"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Interaktive Entscheidungsgeschichten
          </motion.h1>
          <motion.p
            className="text-xl md:text-2xl mb-8 text-white/90 font-rubik"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Erstellen Sie interaktive Entscheidungsgeschichten mit integrierten Quizzen für fesselnde Lernerfahrungen
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Link
              to="/login"
              className="inline-flex items-center space-x-2 px-8 py-4 rounded-lg font-semibold transition-colors font-rubik text-white"
              style={{ backgroundColor: '#c8d8e4' }}
            >
              <span>Jetzt starten</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </Link>
          </motion.div>
        </div>
      </motion.section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold mb-4 font-rubik" style={{ color: '#2b6777' }}>
              Leistungsstarke Funktionen für Pädagogen
            </h2>
            <p className="text-xl font-rubik" style={{ color: '#2b6777' }}>
              Alles was Sie brauchen, um fesselnde interaktive Lernerfahrungen zu erstellen
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="text-center p-8 rounded-xl hover:shadow-lg transition-all border border-gray-100"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div
                  className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6"
                  style={{ backgroundColor: '#c8d8e4' }}
                >
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-4 font-rubik" style={{ color: '#2b6777' }}>
                  {feature.title}
                </h3>
                <p className="font-rubik" style={{ color: '#2b6777' }}>
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ backgroundColor: '#2b6777' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold mb-6 text-white font-rubik">
              Bereit zum Erstellen?
            </h2>
            <p className="text-xl text-white/90 mb-8 font-rubik">
              Schließen Sie sich Pädagogen weltweit an, die das Lernen mit interaktiven Geschichten revolutionieren
            </p>
            <Link
              to="/login"
              className="inline-flex items-center space-x-2 px-8 py-4 rounded-lg font-semibold transition-colors font-rubik text-white"
              style={{ backgroundColor: '#c8d8e4' }}
            >
              <span>Heute kostenlos starten</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;